import { render } from "./MemorialSaved.vue?vue&type=template&id=aa121280"
import script from "./MemorialSaved.vue?vue&type=script&lang=js"
export * from "./MemorialSaved.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__